import { CAL_EVENT_FIELD_PHASES } from './cal-event-field-phases.js';
export function fieldPhaseRank(phase) {
    return CAL_EVENT_FIELD_PHASES.indexOf(phase);
}
//# sourceMappingURL=field-phase-rank.js.map